import React from 'react';
import PropTypes from 'prop-types';
import DiscoverRowWrapper from './DiscoverRowWrapper';
import DimensionsRow from './DimensionsRow';

const DimensionsDiscoverRow = (props) => {
    const { dimensions, userCompany, currentCategory, index, loading } = props;

    return dimensions.length ? (
        <DiscoverRowWrapper
            currentCategory={currentCategory}
            index={index}
            userCompany={userCompany}
        >
            <DimensionsRow dimensions={dimensions} loading={loading} />
        </DiscoverRowWrapper>
    ) : null;
};

DimensionsDiscoverRow.propTypes = {
    currentCategory: PropTypes.object,
    userCompany: PropTypes.object,
    index: PropTypes.number,
    dimensions: PropTypes.array,
    loading: PropTypes.bool
};

export default DimensionsDiscoverRow;
